export default class ListSolutionsByPropertyError extends Error {
}
